import { Component, OnDestroy, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

import { PurchasingService } from '../../services/purchasing.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GlobalsService } from '../../services/globals.service';
import { Tpl3plService } from '../../services/tpl3pl.service';
import { Location } from '@angular/common';


@Component({
	selector: 'app-open-rgas',
	templateUrl: './open-rgas.component.html',
	styleUrls: ['./open-rgas.component.scss']
})
export class OpenRgasComponent implements OnInit, OnChanges, OnDestroy {

	@Input() item: any = false;
	@Input() vendor: any = false;
	@Output() update_item = new EventEmitter < any > ();
	@Output() rgaloaded = new EventEmitter < any > ();
	@Output() po_data = new EventEmitter < any > ();
	@ViewChild(MatSort, { static: false }) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild('confirmCancelRga') confirmCancelRgaRef: ElementRef;

	rgas: MatTableDataSource<any> = new MatTableDataSource([]);
	allrgas: any = { pos: [] };


	headercolumns: string[] = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'orddate',
		'requisitionno',
		'creditvalue',
		'creditpendingvalue',
		'credititems',
		'deliverydate',
		'initiator',
	];

	private readonly baseHeaderColumns = [
		'actions',
		'orderno',
		'status_id',
		'suppname',
		'orddate',
		'requisitionno',
		'creditvalue',
		'creditpendingvalue',
		'credititems',
		'deliverydate',
		'initiator',
	];

	statuses: any = [];
	openRgaData: any = [];
	config: any = [];
	baselink = '';
	reclink = '';
	color = '';
	podetails: any = [];
	vendorSearch = new FormControl('');
	status = new FormControl('CREATED_SUBMITTED');
	searching = false;
	search: any = false;

	private subscriptions: Subscription[] = [];
	private timeoutId: any;

	pendingCancelRgaNo: any;
	cancelReason: any = '';
	cancelNotes = '';
	showReasonError = false;
	predefinedReasons: any[] = [];

	// PGS 360 RMA — only shown when 3PL is configured and enabled
	tpl3plPgsEnabled = false;
	pgsSendingOrderNo: string | null = null;
	pgsResultByOrder: { [orderNo: string]: { success: boolean; message: string; cached?: boolean } } = {};
	private defaultReasons = [
		{ id: '1', label: 'No Longer Needed', code: 'NO_LONGER_NEEDED', requires_notes: '0', sort_order: '1', is_active: '1' },
		{ id: '2', label: 'Vendor Won\'t Accept', code: 'VENDOR_WONT_ACCEPT', requires_notes: '1', sort_order: '2', is_active: '1' },
		{ id: '3', label: 'Items Already Disposed', code: 'ITEMS_DISPOSED', requires_notes: '1', sort_order: '3', is_active: '1' },
		{ id: '4', label: 'Return Window Expired', code: 'WINDOW_EXPIRED', requires_notes: '0', sort_order: '4', is_active: '1' },
		{ id: '5', label: 'Items Sold/Used', code: 'ITEMS_SOLD_USED', requires_notes: '0', sort_order: '5', is_active: '1' },
		{ id: '6', label: 'Vendor Dispute', code: 'VENDOR_DISPUTE', requires_notes: '1', sort_order: '6', is_active: '1' },
		{ id: '7', label: 'Other', code: 'OTHER', requires_notes: '1', sort_order: '99', is_active: '1' }
	];

	constructor(private route: ActivatedRoute, private purchasingService: PurchasingService, private globalsService: GlobalsService, public globalSearchService: GlobalSearchService, public location: Location, private modalService: NgbModal, private tpl3plService: Tpl3plService) {

		this.color = this.globalSearchService.getColor();

	}

	ngOnInit(): void {
		this.config = this.globalsService.getApiConfig();
		this.baselink = this.config.apiServer.poLink;
		this.reclink = this.config.apiServer.recLink;

		// Only set default to 'CREATED_SUBMITTED' if status is null/undefined, not if it's empty string (All)
		if (this.status.value === null || this.status.value === undefined) {
			this.status.setValue('CREATED_SUBMITTED');
		}

		const cancelReasonsSub = this.purchasingService.getRgaCancelReasons().subscribe((r: any) => {
			if (r && r.success && r.data && Array.isArray(r.data) && r.data.length > 0) {
				this.predefinedReasons = r.data;
			} else {
				this.predefinedReasons = this.defaultReasons;
			}
		}, () => {
			this.predefinedReasons = this.defaultReasons;
		});
		this.subscriptions.push(cancelReasonsSub);

		// Subscribe to status filter changes (skip initial value to avoid double load)
		const statusSub = this.status.valueChanges.pipe(skip(1)).subscribe((statusValue: string) => {
			if (statusValue !== null && statusValue !== undefined) {
				this.loadData();
			}
		});
		this.subscriptions.push(statusSub);

		// Check if PGS 360 3PL integration is configured — gates the RMA send column
		const pgsSub = this.tpl3plService.getConfig().subscribe({
			next: (cfg: any) => {
				this.tpl3plPgsEnabled = !!(cfg?.enabled && cfg?.integration_type === 'PGS');
				this.headercolumns = this.tpl3plPgsEnabled
					? [...this.baseHeaderColumns, 'pgs360_rma']
					: [...this.baseHeaderColumns];
			},
			error: () => {
				this.tpl3plPgsEnabled = false;
				this.headercolumns = [...this.baseHeaderColumns];
			}
		});
		this.subscriptions.push(pgsSub);
	}

	loadData() {
		// Use empty string for "All", only default to 'CREATED_SUBMITTED' if status is null/undefined
		const statusFilter = (this.status.value === null || this.status.value === undefined) ? 'CREATED_SUBMITTED' : this.status.value;
		const search: any = {
			status: statusFilter
		};

		if (this.vendor && this.vendor.supplierid) {
			search.vendor = this.vendor;
			search.item = this.item;
		} else {
			search.keywords = this.vendorSearch.value;
		}

		const loadSub = this.purchasingService.searchRgas(search).subscribe((results: any) => {
			this.allrgas = results || { pos: [] };
			this.po_data.emit(results || { pos: [] });
			this.statuses = results?.statuses || [];
			this.setTableData(results?.pos || []);
		});
		this.subscriptions.push(loadSub);
	}

	getStatus(id: any) {
		return this.statuses.filter((st) => {
			return parseFloat(st.status_id) == parseFloat(id)
		})[0];
	}

	/** Send RMA inbound to PGS 360 for the given RGA order. Gated by tpl3plPgsEnabled. */
	sendRgaToPgs(orderNo: string, forceResend = false): void {
		if (!this.tpl3plPgsEnabled || this.pgsSendingOrderNo) { return; }
		this.pgsSendingOrderNo = orderNo;
		const sub = this.purchasingService.sendRmaToPgs(orderNo, forceResend).subscribe({
			next: (result: any) => {
				this.pgsSendingOrderNo = null;
				this.pgsResultByOrder[orderNo] = result;
				this.loadData(); // refresh so tpl3pl_rma_response badge reflects new state
			},
			error: (err: any) => {
				this.pgsSendingOrderNo = null;
				this.pgsResultByOrder[orderNo] = { success: false, message: err?.error?.message || 'Request failed' };
			}
		});
		this.subscriptions.push(sub);
	}

	setTableData(data: any) {
		this.openRgaData = data || [];

		if (!this.rgas) {
			this.rgas = new MatTableDataSource([]);
		}

		this.rgas.data = data || [];

		if (this.sort) {
			this.rgas.sort = this.sort;
		}
		if (this.paginator) {
			this.rgas.paginator = this.paginator;
		}
	}

	loadRga(orderno: any) {
		const loadRgaSub = this.purchasingService.loadRga(orderno).subscribe((result: any) => {
			this.rgaloaded.emit(result);
		});
		this.subscriptions.push(loadRgaSub);
	}


	searchRgas() {
		// Use empty string for "All", only default to 'CREATED_SUBMITTED' if status is null/undefined
		const statusFilter = (this.status.value === null || this.status.value === undefined) ? 'CREATED_SUBMITTED' : this.status.value;
		const search: any = {
			status: statusFilter
		};

		if (this.vendor && this.vendor.supplierid) {
			search.vendor = this.vendor;
			search.item = this.item;
		} else {
			search.keywords = this.vendorSearch.value;
		}

		const searchSub = this.purchasingService.searchRgas(search).subscribe((results: any) => {
			this.allrgas = results || { pos: [] };
			this.po_data.emit(results || { pos: [] });
			this.statuses = results?.statuses || [];
			this.setTableData(results?.pos || []);
		});
		this.subscriptions.push(searchSub);
	}

	updateStatus(event: any, trans: any) {
		const status_details = this.getStatus(event.value);
		if (!this.allrgas?.pos || !Array.isArray(this.allrgas.pos)) {
			console.error('allrgas.pos is not available');
			return;
		}
		const index = this.allrgas.pos.indexOf(trans);
		if (index === -1) {
			console.error('Transaction not found in allrgas.pos');
			return;
		}

		this.allrgas.pos[index].editing = false;
		this.allrgas.pos[index].status_id = status_details.status_id;
		this.allrgas.pos[index].statusname = status_details.name;

		const updateSub = this.purchasingService.updateRgaStatus(this.allrgas.pos[index]).subscribe((result: any) => {
			if (this.vendor?.supplierid && result?.pos) {
				result.pos = result.pos.filter((o) => o.supplierno == this.vendor.supplierid);
			}
			this.allrgas = result || { pos: [] };
			this.po_data.emit(result || { pos: [] });
			this.statuses = result?.statuses || [];
			this.setTableData(result?.pos || []);
		});
		this.subscriptions.push(updateSub);
	}

	exportExcel() {
		if (!this.allrgas?.pos || !Array.isArray(this.allrgas.pos)) {
			console.error('Cannot export: allrgas.pos is not available');
			return;
		}
		this.globalSearchService.exportJsonToExcel(this.allrgas.pos, 'OpenRGAs');
	}

	toggleStatusChange(trans: any) {
		if (!this.allrgas?.pos || !Array.isArray(this.allrgas.pos)) {
			console.error('allrgas.pos is not available');
			return;
		}
		const index = this.allrgas.pos.indexOf(trans);
		if (index === -1) {
			console.error('Transaction not found in allrgas.pos');
			return;
		}
		if (this.allrgas.pos[index].editing) {
			this.allrgas.pos[index].editing = false;
		} else {
			this.allrgas.pos[index].editing = true;
		}
	}

	onInput() {
		const search = this.vendorSearch.value;
		this.searching = true;

		if (!this.rgas) {
			this.rgas = new MatTableDataSource([]);
		}

		const filteredData = this.globalSearchService.filterItem(this.openRgaData, search, 'orderno,supplierno,deliverydate,itemcode,itemdescription,requisitionno');
		this.rgas.data = filteredData || [];

		if (this.sort) {
			this.rgas.sort = this.sort;
		}
		if (this.paginator) {
			this.rgas.paginator = this.paginator;
		}

		this.searching = false;
	}

	announceSortChange(event: any) {
		// MatSort change handler - no action needed
	}

	viewRga(orderno: any, content: any) {
		const viewSub = this.purchasingService.getRga(orderno).subscribe((rga: any) => {
			this.podetails = rga;
			this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then(() => {}, () => {});
		});
		this.subscriptions.push(viewSub);
	}


	back(): void {
		this.location.back()
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes) {
			// Only set default to 'CREATED_SUBMITTED' if status is null/undefined, not if it's empty string (All)
			if (this.status.value === null || this.status.value === undefined) {
				this.status.setValue('CREATED_SUBMITTED');
			}

			// Use empty string for "All", only default to 'CREATED_SUBMITTED' if status is null/undefined
			const statusFilter = (this.status.value === null || this.status.value === undefined) ? 'CREATED_SUBMITTED' : this.status.value;

			if (changes['vendor']) {
				if (this.vendor && this.vendor.supplierid) {
					const vendorDisplay = this.vendor.suppname || this.vendor.supplierid || '';
					if (vendorDisplay) {
						this.vendorSearch.setValue(vendorDisplay, { emitEvent: false });
					}

					const search = {
						item: this.item,
						vendor: this.vendor,
						status: statusFilter
					};

					const vendorSub = this.purchasingService.searchRgas(search).subscribe((results: any) => {
						this.allrgas = results || { pos: [] };
						this.po_data.emit(results || { pos: [] });
						this.statuses = results?.statuses || [];
						this.setTableData(results?.pos || []);
					});
					this.subscriptions.push(vendorSub);
				}
			} else if (changes['item'] && this.vendor && this.vendor.supplierid) {
				const search = {
					item: this.item,
					vendor: this.vendor,
					status: statusFilter
				};

				const itemSub = this.purchasingService.searchRgas(search).subscribe((results: any) => {
					this.allrgas = results || { pos: [] };
					this.po_data.emit(results || { pos: [] });
					this.statuses = results?.statuses || [];
					this.setTableData(results?.pos || []);
				});
				this.subscriptions.push(itemSub);
			}
		}
	}
	ngAfterViewInit() {
		// View initialization complete
	}

	cancelRga(orderno: any) {
		this.pendingCancelRgaNo = orderno;
		this.cancelReason = '';
		this.cancelNotes = '';
		this.showReasonError = false;

		this.modalService.open(this.confirmCancelRgaRef, {
			ariaLabelledBy: 'modal-title',
			size: 'md',
		});
	}

	selectReason(reason: any) {
		this.cancelReason = reason;
		this.showReasonError = false;
		// Clear notes if switching to a reason that doesn't require notes
		if (reason.requires_notes !== '1') {
			this.cancelNotes = '';
		}
	}

	get reasonRequiresNote(): boolean {
		return this.cancelReason?.requires_notes === '1';
	}

	handleConfirmCancelRga(modal: any) {
		if (!this.cancelReason || !this.cancelReason.code ||
		    (this.cancelReason.code === 'OTHER' && !this.cancelNotes.trim())) {
			this.showReasonError = true;
			return;
		}

		this.showReasonError = false;

		const payload: any = {
			orderno: this.pendingCancelRgaNo,
			reason: this.cancelReason.code,
			notes: this.cancelNotes.trim(),
			timestamp: new Date().toISOString()
		};

		const cancelSub = this.purchasingService.cancelCredit(payload).subscribe((result: any) => {
			modal.close();

			if (result.success) {
				this.globalSearchService.showNotification('RGA cancelled successfully', 'success', 'bottom', 'right');

				// Use empty string for "All", only default to 'OPEN' if status is null/undefined
				const statusFilter = (this.status.value === null || this.status.value === undefined) ? 'OPEN' : this.status.value;

				if (this.vendor && this.vendor.supplierid) {
					const search = {
						status: statusFilter,
						vendor: this.vendor,
						item: this.item
					};
					const reloadSub = this.purchasingService.searchRgas(search).subscribe((results: any) => {
						this.allrgas = results || { pos: [] };
						this.po_data.emit(results || { pos: [] });
						this.statuses = results?.statuses || [];
						this.setTableData(results?.pos || []);
					});
					this.subscriptions.push(reloadSub);
				} else {
					const currentSearch = this.vendorSearch.value;
					// Don't set status value here, just use the current value
					this.searchRgas();

					if (currentSearch && currentSearch.trim()) {
						if (this.timeoutId) {
							clearTimeout(this.timeoutId);
						}
						this.timeoutId = setTimeout(() => {
							this.onInput();
						}, 100);
					}
				}
			} else {
				this.globalSearchService.showNotification(result.message || 'Failed to cancel RGA', 'danger', 'bottom', 'right');
			}
		}, (error: any) => {
			modal.close();
			this.globalSearchService.showNotification('Error cancelling RGA', 'danger', 'bottom', 'right');
		});
		this.subscriptions.push(cancelSub);
	}

	cancelModal(modal: any) {
		modal.dismiss();
	}

	ngOnDestroy(): void {
		this.subscriptions.forEach(sub => {
			if (sub && !sub.closed) {
				sub.unsubscribe();
			}
		});
		this.subscriptions = [];

		if (this.timeoutId) {
			clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}
	}
}
